import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.fundcast');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type ChatRole = 'user' | 'assistant';

interface ChatMessage {
    role: ChatRole;
    text: string;
    result?: any;
    error?: string;
}

@Component({
    selector: 'wiz-page-fundcast',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.fundcast/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
}`],
})
export class PageFundcastComponent implements OnInit {
    public question: string = '';
    public loading: boolean = false;
    public error: string = '';
    public messages: ChatMessage[] = [];
    public examples: string[] = [
        '전세 계약을 해지하고 보증금을 돌려받으려면 어떤 법 조항을 봐야 하나요?',
        '임금을 제때 받지 못했을 때 적용되는 법령이 궁금합니다.',
        '상대방 과실로 손해를 입었을 때 손해배상을 청구할 수 있나요?',
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.messages = [{
            role: 'assistant',
            text: '안녕하세요. 법률 질문을 자연어로 입력하면 관련 법령 조항과 참고용 답변을 찾아드릴게요.',
        }];
        await this.service.render();
    }

    public setQuestion(event: Event) {
        this.question = (event.target as HTMLTextAreaElement).value;
        this.error = '';
        this.service.render();
    }

    public useExample(example: string) {
        this.question = example;
        this.error = '';
        this.service.render();
    }

    public canAsk(): boolean {
        return !this.loading && this.question.trim().length >= 2;
    }

    public async ask() {
        const question = this.question.trim();
        if (!question || this.loading) return;

        this.messages.push({ role: 'user', text: question });
        this.question = '';
        this.loading = true;
        this.error = '';
        await this.service.render();

        const res = await wiz.call('ask_legal_question', { question });
        this.loading = false;

        if (res.code === 200) {
            this.messages.push({
                role: 'assistant',
                text: res.data.answer || '답변을 찾지 못했습니다.',
                result: res.data,
            });
        } else {
            const message = res.data?.message || '질문 처리 중 오류가 발생했습니다.';
            this.error = message;
            this.messages.push({
                role: 'assistant',
                text: '죄송합니다. 지금은 답변을 불러오지 못했습니다.',
                error: message,
            });
        }

        await this.service.render();
        setTimeout(() => this.scrollToBottom(), 30);
    }

    public async askSimilar(question: string) {
        this.question = question;
        await this.service.render();
        await this.ask();
    }

    public onKeydown(event: KeyboardEvent) {
        if ((event.ctrlKey || event.metaKey) && event.key === 'Enter') {
            event.preventDefault();
            this.ask();
        }
    }

    public confidencePercent(value: any): number {
        const num = Number(value || 0);
        if (num <= 1) return Math.round(num * 100);
        return Math.round(num);
    }

    public confidenceLabel(value: any): string {
        const percent = this.confidencePercent(value);
        if (percent >= 80) return '높음';
        if (percent >= 50) return '보통';
        if (percent > 0) return '낮음';
        return '미확인';
    }

    public sourceLabel(result: any): string {
        if (!result) return '';
        return result.source === 'mock' ? 'Mock 응답' : 'ETRI 법률 QA API';
    }

    private scrollToBottom() {
        const el = document.getElementById('legal-chat-scroll');
        if (el) el.scrollTop = el.scrollHeight;
    }
}

export default PageFundcastComponent;